export default __webpack_public_path__ + "static/media/21.2397f63b.png";